import ReturnGoodsActions from './actions';

const INITIAL_STATE = {
  data: {},
  dataGoods: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  errorInternal:false,
  helperWarehouseIn:null,
  takingGoodsHelper:null,
  printData:null,
  showData:false
};

export default function ReturnGoodsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ReturnGoodsActions.RESET_LIST:
      return INITIAL_STATE;
    case ReturnGoodsActions.NEW_DATA:
      return { ...state, isProcessing: false,single:null, errorMessage: [], form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case ReturnGoodsActions.UPDATE_DATA:
      return { ...state, errorInternal:false,errorMessage:[],Submit:false,isProcessing: false, single:null,isNewRecord:false};
    case ReturnGoodsActions.RETURN_DATA:
      return { ...state, isProcessing: true,  errorMessage: [], single:null,isNewRecord:false,showModal:true};
   case ReturnGoodsActions.VIEW_ITEM_DATA:
      return { ...state, isProcessing: true,  errorMessage: [], single:null,isNewRecord:false,showModal:true};
    case ReturnGoodsActions.VIEW_DATA:
      return { ...state, isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
   case ReturnGoodsActions.DATA_GOODS:
       return { ...state,  isError: false, dataGoods: action.payload, errorMessage: [],isProcessing:false, showData:true};
    case ReturnGoodsActions.RESET_DATA:
      return { ...state, isProcessing: false, form:INITIAL_STATE.form,showModal:false, showData:false};
    case ReturnGoodsActions.DELETE_DATA:
      return { ...state, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case ReturnGoodsActions.ON_SUBMIT:
     return { ...state, errorInternal: false, onSubmit: true };
    case ReturnGoodsActions.SHOW_DATA:
      return { ...state,  isError: false, data: action.payload, errorMessage: [],isProcessing:false, showData:false };
    case ReturnGoodsActions.SUCCESS_DATA:
      return { ...state, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false, isProcessing:false};
    case ReturnGoodsActions.PROCESS_DATA:
      return { ...state, isProcessing: true, isError: false,isSuccess:false};
    case ReturnGoodsActions.APPROVE:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,};
    case ReturnGoodsActions.REJECT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,};
    case ReturnGoodsActions.ERROR_DATA:
      return { ...state,  isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false,dataGoods:{},showData:false };
    case ReturnGoodsActions.GET_HELPER_RETURN_GOODS_FULL:
      return { ...state, isError: false,isSuccess:false,onSubmit:false, takingGoodsHelper:action.payload}; 
    case ReturnGoodsActions.CANCEL_DATA:
          return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,};  
    case ReturnGoodsActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case ReturnGoodsActions.BEFORE_PRINT_RETURN_GOODS:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printData:null};
    case ReturnGoodsActions.PRINT_RETURN_GOODS:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printData:action.payload};    
        
    default:
      return state;
    }
}


